import { NSARouterMakerResult } from "namirasoft-account-react";
import { SortItem } from "namirasoft-core";
import { GatewayKnowledgebaseInputRow, KnowledgebaseRow } from "namirasoft-inference";
import { NamirasoftMap } from "namirasoft-site-map";
import { IBaseComponentProps, NSBox, NSBoxEntity, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

export interface GatewayKnowledgebaseLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
    index: number;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: GatewayKnowledgebaseInputRow | null) => void;
}

export default class GatewayKnowledgebaseLine extends Component<GatewayKnowledgebaseLineProps>
{
    static IS_DIRTY(value: GatewayKnowledgebaseInputRow | null): boolean
    {
        if (value && value.knowledgebase_id)
            return true;
        return false;
    }

    private NSBoxEntity_KnowledgebaseId = createRef<NSBoxEntity<KnowledgebaseRow>>();

    constructor(props: GatewayKnowledgebaseLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): GatewayKnowledgebaseInputRow | null
    {
        let knowledgebase_id = this.NSBoxEntity_KnowledgebaseId.current?.getValueOne(checkError) ?? "";
        if (!knowledgebase_id)
            return null;
        return { knowledgebase_id };
    }

    setValue(value: GatewayKnowledgebaseInputRow)
    {
        this.NSBoxEntity_KnowledgebaseId.current?.setValue(value.knowledgebase_id);
    }

    isDirty(): boolean
    {
        return GatewayKnowledgebaseLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        return (
            <NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
                <NSBoxEntity<KnowledgebaseRow>
                    ref={this.NSBoxEntity_KnowledgebaseId}
                    {...this.props}
                    title={`Knowledgebase ID ${this.props.index + 1}`}
                    required
                    multiple={false}
                    info={{ link: "https://namirasoft.com/inference/console-guide/gateway/#field-knowledgebases" }}
                    table={namirasoft.inference.tables.knowledgebase}
                    getValue={(item) => item.id}
                    getTitle={(item) => item.name}
                    getSort={() => new SortItem(namirasoft.inference.tables.knowledgebase, namirasoft.inference.tables.knowledgebase.columns.name, true)}
                    style={{ width: NSBox.width.double }}
                    onChanged={this.onChanged}
                    menu={{
                        builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
                        items: []
                    }}
                />
            </NSRow>
        );
    }
}